import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';

import Layout from './components/layout/Layout';
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Legal from './Pages/Legal';
import Privacy from './Pages/Privacy';
import Cookies from './Pages/Cookies';
import NotFound from './Pages/NotFound';

import ArtHome from './Pages/art/ArtHome';
import Gallery from './Pages/art/Gallery';
import Projects from './Pages/art/Projects';
import ProjectDetail from './Pages/art/ProjectDetail';
import Commissions from './Pages/art/Commissions';

import StreamHome from './Pages/stream/StreamHome';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />

          {/* Legal Pages */}
          <Route path="legal" element={<Legal />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<Cookies />} />
          
          {/* Art Ecosystem */}
          <Route path="art">
            <Route index element={<ArtHome />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="commissions" element={<Commissions />} />
          </Route>

          {/* Stream Ecosystem */}
          <Route path="stream">
            <Route index element={<StreamHome />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default App;
